// Shared UX helpers for the achievement gamification flow.
//
// `guestNudge(action)` — if the user is unauthenticated, blocks the
//   given click event and shows a toast steering them to sign in. Returns
//   `true` if the click was blocked (caller should return early).
//
// `celebrateAchievement(navigate, key)` — pops the "Achievement unlocked"
//   toast pointing at /profile. Called by report/review success handlers
//   when the API responds with `new_achievement`.
import { toast } from "sonner";

const GUEST_COPY = "Create a free account to share updates, save routes, and earn your first Skald badge.";

export function guestNudge(user, event) {
  if (user) return false;
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  toast(GUEST_COPY, {
    duration: 6000,
    action: {
      label: "Sign in",
      onClick: () => { window.location.href = "/profile"; },
    },
  });
  return true;
}

export function celebrateAchievement(navigate, key) {
  if (!key) return;
  const clickable = () => {
    if (navigate) navigate("/profile");
    else window.location.href = "/profile";
  };
  toast("\u{1F6E1}\uFE0F Achievement Unlocked! Tap to view your Trophy Wall.", {
    duration: 8000,
    action: { label: "View", onClick: clickable },
  });
}

// Named Norse flourish per rune, used by the one-shot celebration toast
// fired when the walker holds a rune they haven't been toasted for yet.
// The copy intentionally doesn't repeat "achievement unlocked" so it
// stands apart from the inline flow (reports, reviews, scout votes).
const _RUNE_FLOURISH = {
  messenger: "🐾 Rune earned: The Messenger! A raven carries your word to the pack.",
  skald: "🐾 Rune earned: The Skald! Your tale will travel the trails.",
  watchman: "🐾 Rune earned: The Watchman! The pack walks safer thanks to you.",
  trail_scout: "🐾 Rune earned: The Trail Scout! The pack salutes you.",
  master_scout: "🐾 Rune earned: The Master Scout! A rune-crown of paths now bears your name.",
};

export function celebrateRune(navigate, key) {
  if (!key) return;
  const msg = _RUNE_FLOURISH[key] || `🐾 Rune earned: ${key}! The pack salutes you.`;
  const go = () => {
    if (navigate) navigate("/profile");
    else window.location.href = "/profile";
  };
  toast(msg, {
    duration: 9000,
    action: { label: "View", onClick: go },
  });
}
